"use client";

import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DownloadCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="download-cta" className="section-dark relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.08] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542868/img/topographic_texture.png)] bg-cover bg-center fixed" style={{
      backgroundAttachment: "fixed"
    }} />

      {}
      <div ref={ref} className={`
          relative z-10 container mx-auto px-4 max-w-4xl text-center
          transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}
        `}>
        {}
        <p className="text-dark-foreground/80 uppercase tracking-widest text-xs font-sans font-semibold mb-3 leading-tight">
          Your Essential France Resource
        </p>

        {}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-dark-foreground mb-6 leading-tight">
          Download The Free Survival Kit PDF
        </h2>

        {}
        <p className="text-dark-foreground/90 text-lg md:text-xl mb-8 max-w-2xl mx-auto leading-snug">
          Get instant access to our comprehensive budget travel guide with insider tips, cost comparisons, and hidden gems across France.
        </p>

        {}
        <Button size="lg" className="
            text-lg px-8 py-6 h-auto
            bg-accent text-foreground-accent
            hover:bg-accent-hover hover:scale-[1.03]
            active:scale-100
            transition-all duration-[80ms] ease-[var(--ease-spring)]
            shadow-medium
          ">
          <Download className="size-5" />
          Download Free PDF
        </Button>
      </div>
    </section>;
}